
export class Needs {

    constructor(title, isButton) {
        this.title = title;
        this.isButton = isButton !== undefined ? isButton : false;
    }

}



// WEBPACK FOOTER //
// ./src/content/index-page/schema/needs.class.js